var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.231 12.2598L13.691 11.9698C13.3924 11.9347 13.0896 11.9678 12.8056 12.0665C12.5215 12.1652 12.2635 12.327 12.051 12.5398L10.211 14.3798C7.37241 12.9357 5.06508 10.6284 3.62102 7.78977L5.47102 5.93977C5.90102 5.50977 6.11102 4.90977 6.04102 4.29977L5.75102 1.77977C5.69453 1.29186 5.46048 0.841791 5.09348 0.515361C4.72648 0.188932 4.25219 0.00896555 3.76102 0.0097683H2.03102C0.901018 0.0097683 -0.0389828 0.949768 0.0310172 2.07977C0.561017 10.6198 7.39102 17.4398 15.921 17.9698C17.051 18.0398 17.991 17.0998 17.991 15.9698V14.2398C18.001 13.2298 17.241 12.3798 16.231 12.2598Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.97e1837314705f08e546a9efd08a95dc.svg";
export { ForwardRef as ReactComponent };